import React, { useState, useEffect} from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from 'react-router-dom';
import { endpoints } from "../../../services/apiurl";
import { InfinitySpin } from "react-loader-spinner";
import Input from "../../UI/Input/Input";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Grid,FormControl } from "@mui/material";
import Card from "@mui/material/Card";
import PageTitle from "../../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Visibility } from "@mui/icons-material";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";


const RestaurentsDetail = () => {

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [DataisLoaded, setDataisLoaded] = useState(false);
  const [show_app, setShowApp] = useState("");
  const [show_web, setShowWeb] = useState("");
  const [order_by_name, setOrderBy] = useState("");

  useEffect(() => {
    fetchData(1, perPage);
  }, [perPage]);

  useEffect(() => {
    // handleSearch(1, perPage);
  }, [perPage]);

  //console.log(localStorage.getItem("user"));
  let a = localStorage.getItem("user");
  let b = JSON.parse(a);
  

  let rest_id = b.restro_id;

  const fetchData = async (page, per_page) => {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;

    await axios
      .post(endpoints.getRestaurents, {
        page,
        per_page,
        user_id,
        restro_id,
      })
      .then(
        (response) => {
          //console.log(response.data.data);
          //console.log(response.data.total);

          setIsLoaded(true);
          setItems(response.data.data);
          setTotalRows(response.data.total);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const columns = [
    {
      name: "NAME",
      selector: (row) => row.name,
    },

    {
      name: "STATUS",
      selector: (row) => (row.status == 1 ? "Active" : "Inactive"),
    },
    {
      name: "STATUS(App)",
      selector: (row) => (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={row.id + "check1"}
            {...(row.show_app === 1 ? { checked: "checked" } : {})}
            onClick={() => sub(row.id, row.show_app, "show_app")}
          />
          <label
            className="custom-control-label"
            style={{ marginBottom: "21px", cursor: "pointer" }}
            htmlFor={row.id + "check1"} 
          ></label>
        </div>
      ),
    },

    {
      name: "STATUS(Web)",
      selector: (row) => (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={row.id + "check2"}
            {...(row.show_web === 1 ? { checked: "checked" } : {})}
            onClick={() => sub(row.id, row.show_web, "show_web")}
          />
          <label
            className="custom-control-label"
            style={{ marginBottom: "21px", cursor: "pointer" }}
            htmlFor={row.id + "check2"}
          ></label>
        </div>
      ),
    },

    {
      name: "Reservation Form URL",
      selector: (row) => (
        <div>
          <Button
            variant="contained"
           style={{fontSize:"12px"}}
            href={`https://menu.firstfiddle.in/${row.slug}/guest-reservation`}
            target="_blank"
          >
            Reservation Form
          </Button>
        </div>
      ),
    
    },
    {
      name: "Lead Form URL",
      selector: (row) => (
        <div>
          <Button
            variant="contained"
            style={{fontSize:"12px"}}
            href={`https://menu.firstfiddle.in/${row.slug}/lead-form`}
            target="_blank"
          >
            Lead Form
          </Button>
        </div>
      ),
    
    },

    {
      name: "ACTION",
      cell: (row) => (
        <div>
          {" "}
          <Link to={`/dashboard/eddrestaurents/${row.id}`}>
            {" "}
            <EditIcon />{" "}
          </Link>
          <Link variant="contained" to={`/dashboard/sectionrest/${row.id}`}>
  <Visibility />
</Link>

          <Link
            className="error"
            style={{ marginTop: "0px", marginLeft: "0px" }}
            onClick={() => {
              confirmAlert({
                title: "Confirm",
                message: "Do you really want to delete?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => removeContactHandler(row.id),
                  },
                  {
                    label: "No",
                    onClick: () => {},
                  },
                ],
              });
            }}
          >
            <DeleteIcon />
          </Link>
        </div>
      ),
      selector: (row) => row.id,
    
    },
  ];

  const sub = async (id, oldStatus, colName) => {
    const newStatus = oldStatus === 1 ? 0 : 1;

    try {
      // Update local state directly
      const updatedItems = items.map((item) =>
        item.id === id ? { ...item, [colName]: newStatus } : item
      );
      setItems(updatedItems);

      // Call API to update server-side status
      const response = await axios.post(endpoints.app_webRestStatus, {
        id,
        status: newStatus,
        col_name: colName,
      });

      // Show toaster notification
      const message = newStatus === 1 ? "Activated" : "Deactivated";
      toast.success(`Status ${message} successfully!`, { autoClose: 2000 });
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status. Please try again later.");
    }
  };

  const removeContactHandler = async (id) => {
    await axios
      .post(endpoints.deleteRestaurents, { id })
      .then((response) => {});
    const newContactList = items.filter((contact) => {
      return contact.id !== id;
    });
    setItems(newContactList);
  };

  const handleSearch = async (
    page,
    per_page,
    show_web,
    show_app,
    order_by_name,
    searchQuery = ""
  ) => {
    try {
      const response = await axios.post(endpoints.rest_filter, {
        page,
        per_page,
        searchQuery,
        show_web,
        show_app,
        order_by_name,
      });
      setIsLoaded(true);
      setItems(response.data.data);
      setTotalRows(response.data.total);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
      //console.error("Error filtering restaurants:", error);
    }
  };

  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    setSearchQuery(inputValue);

    if (rest_id === 0) {
      if (inputValue.trim() !== "") {
        await handleSearch(1, 10, show_web, show_app, order_by_name, inputValue);
      } else {
        await handleSearch(1, 10, show_web, show_app, order_by_name, "");
      }
    } else {
      fetchData(1, 10);
    }
  };


  const handlePageChange = (page) => {
    if (rest_id === 0) {
      handleSearch(page, 10, show_web, show_app, order_by_name, searchQuery);
    } else {
      fetchData(page, 10);
    }
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    if (rest_id === 0) {
      handleSearch(
        page,
        newPerPage,
        show_web,
        show_app,
        order_by_name,
        searchQuery
      );
    } else {
      fetchData(page, newPerPage);
    }
  };

  

  const handleInputStatusChange = async (event) => {
    const value = event.target.value;
    setShowApp(value);
    await handleSearch(1, 10, show_web, value, order_by_name, "");
  };

  const handleInputStatusWebChange = async (event) => {
    const value = event.target.value;
    setShowWeb(value);
    await handleSearch(1, 10, value, show_app, order_by_name, "");
  };

  const handleInputOrderChange = async (event) => {
    const value = event.target.value;
    setOrderBy(value);
    await handleSearch(1, 10, show_web, show_app, value, "");
  };

  const handleResetFilters = async () => {
    // Reset all filter states
    setShowApp("");
    setShowWeb("");
    setOrderBy("");
    setSearchQuery("");

    await handleSearch(1, 10, "", "", "", "");
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div>

<div className="spinner">
            <InfinitySpin
              visible={true}
              width="200"
              color="#fbaa1a"
              ariaLabel="infinity-spin-loading"
            />
            
          </div>
    </div>;
  } else {
    return (
      <div className="App">
        {rest_id === 0 ? (
          <PageTitle
          
            title="Restaurants List"
            linkurl="/dashboard/addrestaurents"
            linkTitle="Add Restaurant"
          
          />
        ) : (
          ""
        )}

        <Card className="mt-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            highlightOnHover
            subHeader
            subHeaderComponent={
              rest_id === 0 && (
              <Grid
                container
                spacing={2}
                justifyContent="left"
                alignItems="center"
                style={{ padding: "10px" }}
              >
              
                <Grid item xs={12} md={2} textAlign="center">
                  <FormControl fullWidth style={{ marginTop: "-26px" }}>
                    <Input
                      type="text"
                      value={searchQuery}
                      onChange={handleInputChange}
                      place="Search restaurant"
                      className="form-control"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2} textAlign="center">
                  <FormControl fullWidth>
                    <select
                      name="show_app"
                      value={show_app}
                      onChange={handleInputStatusChange}
                      required
                      className="form-control"
                      style={{ fontSize: "14px" }}
                    >
                      <option value="">Status App</option>
                      <option value="1">Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </FormControl>
                </Grid>
            
                <Grid item xs={12} md={2} textAlign="center">
                  <FormControl fullWidth>
                    <select
                      name="show_web"
                      value={show_web}
                      onChange={handleInputStatusWebChange}
                      required
                      className="form-control"
                      style={{ fontSize: "14px" }}
                    >
                      <option value="">Status Web</option>
                      <option value="1">Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2} textAlign="center">
                  <FormControl fullWidth>
                    <select
                      name="order_by_name"
                      value={order_by_name}
                      onChange={handleInputOrderChange}
                      required
                      className="form-control"
                      style={{ fontSize: "14px" }}
                    >
                      <option value="">Order By NAME</option>
                      <option value="ASC">Asscending</option>
                      <option value="DESC">Decending</option>
                    </select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleResetFilters}
                  >
                    Reset Filters
                  </Button>
                </Grid>
             
              </Grid>
              )
            }
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default RestaurentsDetail;
